import toolsSlice from './slice';

export const {
    upalodImage,
    upalodImageSuccess,
    upalodImageError,

    generateDescription,
    generateDescriptionSuccess,
    generateDescriptionError,
    
    checkImageDescription,
    checkImageDescriptionSuccess,
    checkImageDescriptionError,

    getWebsiteContext,
    getWebsiteContextSuccess,
    getWebsiteContextError,

    auditSinglePage,
    auditSinglePageSuccess,
    auditSinglePageError,

    auditCodeSnippet,
    auditCodeSnippetSuccess,
    auditCodeSnippetError,

    languageLevelChecker,
    languageLevelCheckerSuccess,
    languageLevelCheckerError,

    singlePagesDataI,
    singlePagesDataSuccess,
    singlePagesDataError,

    singlePageAuditH,
    singlePageAuditSuccessH,
    singlePageAuditErrorH,    

    codeSnippetCheckerI,
    codeSnippetCheckerSuccess,
    codeSnippetCheckerError,

    codeSnippetCheckerH,
    codeSnippetCheckerSuccessH,
    codeSnippetCheckerErrorH,    

} = toolsSlice.actions; 
export default toolsSlice.reducer;

export * from './types';